import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'

const state = {
  chart: {
    title: null,
    status: {
      loading: false,
      noData: false
    },
    series: [],
    chartOptions: {
      labels: [],
      dataLabels: {
        enabled: false
      },
      colors: ['#307fff', '#56aee3', '#56e2cf', '#5668e2', '#cf55e2', '#e356ae', '#e25567', '#e28955', '#e2cf56', '#aee255'],
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'ligth',
          type: 'vertical',
          shadeIntensity: 0.4,
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100]
        }
      },
      legend: {
        position: 'bottom'
      },
      responsive: [{
        breakpoint: 960,
        options: {
          legend: {
            position: 'bottom'
          }
        }
      }]
    }
  }
}

const getters = {

}

let elemRef = null

const actions = {
  getChart ({ commit }, filter) {
    commit('SET_loading', true)
    return new Promise((resolve, reject) => {
      if (filter.elemRef) {
        elemRef = filter.elemRef
      }
      axios.post(AppUrl, {
        task: 'pricesDistribution',
        payload: {
          sellers: filter.sellers,
          categories: filter.categories,
          brands: filter.brands
        }
      })
        .then(response => {
          commit('SET_title', response.data.payload.title)
          if (Object.keys(response.data.payload.distribution).length > 0) {
            commit('SET_loading', false)
            commit('SET_noData', false)
            commit('SET_pricesDistribution', response.data.payload.distribution)
            resolve()
          } else {
            commit('SET_loading', false)
            commit('SET_noData', true)
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}

const mutations = {
  SET_loading (state, bool) {
    state.chart.status.loading = bool
  },
  SET_noData (state, bool) {
    state.chart.status.noData = bool
  },
  SET_pricesDistribution (state, data) {
    state.chart.chartOptions.labels = []
    state.chart.series = []
    state.chart.chartOptions.labels = Object.keys(data)
    for (let item in data) {
      state.chart.series.push(Number(data[item]))
    }
    if (elemRef) {
      elemRef.refresh()
    }
  },
  SET_title (state, data) {
    state.chart.title = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/analytics/priceDistribution.js